import { iconFactory } from '../iconFactory'

export interface StockProps {
  fill?: never
  variant?: 'available' | 'unavailable' | 'reserved'
}

export const Stock = iconFactory(
  'Stock',
  ({ variant = 'available' }: StockProps) => {
    switch (variant) {
      case 'unavailable':
        return (
          <path
            fill="#ccc"
            transform="rotate(45 12 12)"
            d="M11 11V3h2v8h8v2h-8v8h-2v-8H3v-2h8z"
          />
        )

      case 'reserved':
        return (
          <path
            d="M20 8.4L18.6 7L11 14.6L6.4 10L5 11.4L11 17.4L20 8.4Z"
            fill="#333"
          />
        )

      case 'available':
      default:
        return (
          <path
            fill="#00C853"
            d="M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-2a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0-2a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
          />
        )
    }
  },
)
